var map = {
	"./Airbrake/Security.md": 91657,
	"./Airtable/Security.md": 43440,
	"./Asana/Security.md": 73022,
	"./Assembla/Security.md": 96608,
	"./Axosoft/Security.md": 15090,
	"./AzureDevOps/Security.md": 12982,
	"./Backlog/Security.md": 58861,
	"./Bitbucket/Security.md": 93687,
	"./Breeze/Security.md": 43061,
	"./Bugasura/Security.md": 98576,
	"./Bugherd/Security.md": 11009,
	"./Bugsnag/Security.md": 77329,
	"./Bugzilla/Security.md": 23482,
	"./Clickup/Security.md": 12855,
	"./Datadog/Security.md": 46182,
	"./DevRev/Security.md": 41012,
	"./Favro/Security.md": 16250,
	"./Flock/Security.md": 64531,
	"./FogBugz/Security.md": 54316,
	"./Github/Security.md": 7169,
	"./GithubCopilotChat/Security.md": 20729,
	"./Gitlab/Security.md": 5057,
	"./GoodDay/Security.md": 52263,
	"./GoogleChat/Security.md": 53775,
	"./Hive/Security.md": 89306,
	"./Jira/Security.md": 72852,
	"./LinearApp/Security.md": 18756,
	"./Mantis/Security.md": 97480,
	"./Mattermost/Security.md": 24374,
	"./MicrosoftTeams/Security.md": 74198,
	"./Miro/Security.md": 25711,
	"./Monday/Security.md": 44496,
	"./NewRelic/Security.md": 21631,
	"./Notion/Security.md": 42243,
	"./PagerDuty/Security.md": 61365,
	"./Paymo/Security.md": 62586,
	"./PivotalTracker/Security.md": 56641,
	"./Practitest/Security.md": 69143,
	"./Redmine/Security.md": 95720,
	"./RocketChat/Security.md": 85314,
	"./ServiceNow/Security.md": 98939,
	"./Shopify/Security.md": 40846,
	"./Shortcut/Security.md": 94450,
	"./Slack/Security.md": 67320,
	"./SpiraTeam/Security.md": 72226,
	"./SumoLogic/Security.md": 72802,
	"./Taiga/Security.md": 29693,
	"./TargetProcess/Security.md": 49510,
	"./Teamwork/Security.md": 47204,
	"./Trello/Security.md": 70782,
	"./Userback/Security.md": 10880,
	"./Webex/Security.md": 57585,
	"./Webhooks/Security.md": 66454,
	"./Wrike/Security.md": 37096,
	"./YouTrack/Security.md": 93378,
	"./Zenkit/Security.md": 37397,
	"./Zipboard/Security.md": 30263,
	"./ZohoBugTracker/Security.md": 63432,
	"./ZohoCliq/Security.md": 25273,
	"./ZohoProject/Security.md": 41885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39103;